import { FC, useMemo, useState } from "react";
import { StoreCategoryModel, StoreProductModel } from "../../models";
import { ProductAddOnModal, ShortDescription } from "..";
import { useLayout, useShipping } from "../../context";
import { useOrderOption } from "../../hooks";
import { formatCurrency } from "../../utilities";
import { OrderType } from "../../enums";
import { Card, CardBody } from "react-bootstrap";
import { isEmpty, ucwords } from "../../helpers";
import { useProductPrice } from "../../hooks";
import { BiSolidOffer } from "react-icons/bi";
import CartConfirmModal from "../cart/_modals/CartConfirmModal";
import { HiOutlinePlusSmall } from "react-icons/hi2";

type Props = {
  product: StoreProductModel;
  category?: StoreCategoryModel;
};

const AddProductCard: FC<Props> = ({ product }) => {
  // const { loyaltyProducts } = useLoyalty();
  const { orderOption } = useOrderOption();
  const { shippingLocation } = useShipping();

  const { setShowOptionModal } = useLayout();

  const [showAddOnModal, setShowAddOnModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  // const isLoyaltyProduct = loyaltyProducts.includes(product.id);

  const handleClick = () => {
    setShowAddOnModal(true);
  };

  const handleClose = () => {
    setShowAddOnModal(false);
  };

  const handleSubmit = () => {
    // setShowDetailModal(false);
    setShowAddOnModal(false);
    if (
      !orderOption.order_date ||
      (orderOption.type_id == OrderType.DELIVERY &&
        !shippingLocation?.formatted_address)
    )
      setShowOptionModal(true);
    else setShowConfirmModal(true);
  };

  // Check Availability
  // const isAvailable = useMemo(() => {

  //   if (!product.weekdays?.length) return true;

  //   return product.weekdays.includes(new Date().getDay());

  // }, [product.weekdays]);

  const productTag = useMemo(() => {
    return product.time?.map((t) => t.type).join("/") || "";
  }, [product.time]);

  const productPrice = useProductPrice(product);
  // const applicableCoupons = useProductCoupons(product);

  return (
    <>
      <Card className="food_item_colm product-card d-flex flex-row flex-fill">
        <CardBody className="product-content food_item_colm_left d-flex flex-column justify-content-center flex-fill position-relative align-items-start">
          {/* <span> */}
          <h5
            className="d-flex justify-content-between align-items-start gap-2 cursor-pointer mb-1"
            onClick={handleClick}
          >
            {ucwords(product.product_name)}
            {productTag && (
              <span className="product-tag ms-2">{productTag}</span>
            )}
          </h5>
          {product.product_desc && (
            <ShortDescription
              description={product.product_desc}
              onClick={handleClick}
            />
          )}
          {/* </span> */}
          <span className="d-flex flex-row justify-content-start align-items-center gap-3">
            <strong>
              {product.product_price > 0
                ? formatCurrency(productPrice)
                : product.product_dprice}
            </strong>
            {!isEmpty(product.modifier_group) && (
              <span
                className="cursor-pointer customize-btn"
                onClick={handleClick}
              >
                Customize
              </span>
            )}
          </span>
          {/* {!isEmpty(applicableCoupons) && (
            <span className='coupon-code d-flex align-items-center gap-1'><BiSolidOffer size={12} /> {applicableCoupons.map(coupon => coupon.code).join(" | ")}</span>
          )} */}
          {product.coupon && (
            <span className="coupon-code d-flex align-items-center gap-1">
              <BiSolidOffer size={12} /> {product.coupon.title}
            </span>
          )}
        </CardBody>
        <div
          className="product-image-frame cursor-pointer"
          onClick={handleClick}
        >
          {product.product_image ? (
            <>
              <img
                className="product-image rounded object-fit-contain"
                src={product.product_image}
                alt=""
              />
              <span className={"overlay"}></span>
            </>
          ) : (
            <div className="product-image-placeholder">
              {/* <ImageIcon size={22} /> */}
              {/* <span>No image</span> */}
            </div>
          )}
        </div>
        <div className="plus_btn">
          <button onClick={handleClick}>
            <HiOutlinePlusSmall size={30} />
          </button>
        </div>
      </Card>

      <ProductAddOnModal
        product={product}
        show={showAddOnModal}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <CartConfirmModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        product={product}
      />
    </>
  );
};

export default AddProductCard;
